import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import styles from "../common.module.css";
import { authClient } from "./defaults";

export default function RegisterPage() {
  const navigate = useNavigate();
  const [firstName, setFirstName] = useState("");
  const [lastName, setLastName] = useState("");
  const [org, setOrg] = useState("");
  const [role, setRole] = useState("");
  const [popupMessage, setPopupMessage] = useState("");
  const [showPopup, setShowPopup] = useState(false);
  const [loading, setLoading] = useState(false);
  const [isSuccess, setIsSuccess] = useState(false);

  const roles = [
    "Admin",
    "Developer",
    "Architect",
    "Analyst",
    "Support",
    "Engineer",
    "Manager",
    "DevOps",
  ];

  const handleRegister = async (e) => {
    e.preventDefault();
    if (!firstName || !lastName || !role) {
      setPopupMessage("All fields are required.");
      setIsSuccess(false);
      setShowPopup(true);
      return;
    }

    setLoading(true);

    try {
      const response = await authClient.post(
        "/register",
        {
          first_name: firstName,
          last_name: lastName,
          org: org,
          role,
        },
      );

      if (response.status === 200) {
        setPopupMessage("Registration successful! Redirecting to dashboard...");
        setIsSuccess(true);
        setShowPopup(true);
      }
    } catch (err) {
      if (err.response) {
        const serverMessage =
          err.response.data?.message || "An error occurred. Please try again.";
        setPopupMessage(serverMessage);
      } else if (err.request) {
        setPopupMessage("No response from server. Please check your connection.");
      } else {
        setPopupMessage("An unexpected error occurred. Please try again.");
      }
      setIsSuccess(false);
      setShowPopup(true);
    } finally {
      setLoading(false);
    }
  };

  const closePopup = () => {
    setShowPopup(false);
    if (isSuccess) {
      navigate("/user-agreement");
    }
  };

  return (
    <div className={styles.loginPageWrapper}>
      <div className={styles.leftPane}>
        <div className={styles.card}>
          <form className={styles.registrationForm} onSubmit={handleRegister}>
            <h1 className={styles.title}>Register</h1>
            <p className={styles.subtitle}>Hello, Thank you for choosing Us!!</p>
            <input
              type="text"
              placeholder="First Name"
              className={styles.inputField}
              value={firstName}
              onChange={(e) => setFirstName(e.target.value)}
            />
            <input
              type="text"
              placeholder="Last Name"
              className={styles.inputField}
              value={lastName}
              onChange={(e) => setLastName(e.target.value)}
            />
            <input
              type="text"
              placeholder="Organization"
              className={styles.inputField}
              value={org}
              onChange={(e) => setOrg(e.target.value)}
            />
            <select
              className={styles.inputField}
              value={role}
              onChange={(e) => setRole(e.target.value)}
            >
              <option value="" disabled>
                Select Role
              </option>
              {roles.map((roleOption) => (
                <option key={roleOption} value={roleOption}>
                  {roleOption}
                </option>
              ))}
            </select>
            <button
              className={styles.button}
              type="submit"
              disabled={loading}
            >
              {loading ? "Registering..." : "Register"}
            </button>
          </form>
        </div>
      </div>

      <div className={styles.rightPane} style={{ backgroundImage: "url('/loginrightbg.svg')" }}>
        <div className={styles.loginOverlayContent}>
          <h2 className={styles.loginOverlayHeading}>Welcome to SpecWizard</h2>
          <p className={styles.loginOverlaySubtext}>
            We are building Specwizard with feedback
            from the best devs in the world.
          </p>
        </div>
      </div>

      {/* Centered Popup */}
      {showPopup && (
        <div className={styles.popupOverlay}>
          <div className={styles.popup}>
            <h3>{isSuccess ? "Success" : "Error"}</h3>
            <p>{popupMessage}</p>
            <button onClick={closePopup} className={styles.popupButton}>
              OK
            </button>
          </div>
        </div>
      )}
    </div>
  );
}
